import Vue from 'vue/dist/vue.js';
import dailygraph from './_vuechart'
import weeklygraph from './_vuechartWeekly'
import Chart from 'chart.js';

export default {
    _container : null,
    _canvas: null,
    _form : null,
    _postNr : null,
    _color: null,
    _bordercolor: null,

    init() {
        this._container = document.getElementById('spotprisgraph');
        this._canvas = document.querySelector('[data-graph-daily]');
        
        if (!this._container) {
            return;
        }
        if(this._canvas){
            this._color = this._canvas.getAttribute('data-color');
            this._bordercolor = this._canvas.getAttribute('data-border-color');
        }
        
        new Vue({
            el        : this._container,
            delimiters: ['[[', ']]'],
            data: {
                postnrError : null,
                postnr : null,
                canvas: this._canvas,
                response: [],
                pricelist : [ ],
                option : 'daily',
                spotpriceError : null,
                minpris : null,
                maxpris : null,
                color: this._color,
                bordercolor: this._bordercolor,
                avg : null,
                sitetype :  this._container.getAttribute('data-site'),
                currentTab : 'daily',
                area: null,
                areaSpot: null,
                chartConfig : {
                    labels: [],
                    datasets: [{
                        label: '',
                        data: [],
                        pointBackgroundColor:'white',
                        pointHoverRadius: 10,
                        pointRadius: 5,
                        pointBorderColor: this._bordercolor,
                        pointHoverBackgroundColor: this._color,
                        backgroundColor: this._color,
                        borderColor:this._bordercolor,
                        borderWidth: 1
                    }],
                },
                barChartConfig : [],
                options:{
                    layout: {
                        padding: {
                            top: 50
                        }
                    },
                    responsive: true,
                    legend: {
                        display: false,
                    },
                    events: ['mousemove'],
                    onHover: (event, chartElement) => {
                        event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
                    },
                    hover: {
                        "animationDuration": 0
                    },
                
                    scales: {
                        yAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            },
                        
                            ticks: {
                                beginAtZero: true,
                                stepSize: 2
                            }
                        }],
                        xAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            },
                            ticks: {
                            }
                        }]
                    },
                    tooltips: {
                        enabled : true,
                        backgroundColor: this._color,
                        bodyFontColor: 'white',
                        bodyFontStyle: 'bold',
                     //   titleFontStyle: 'normal',
                        bodyFontSize: 14,
                        bodySpacing: 4,
                        titleMarginBottom: 10,
                        xPadding: 10,
                        yPadding: 10,
                        caretPadding: 20,

                        custom: function (tooltip) {
                            if (!tooltip) return;
                            tooltip.displayColors = false;
                        },
                        callbacks: {
                            label: function (tooltipItem, chart) {
                                let label = chart.datasets[tooltipItem.datasetIndex].label || '';
                                label += Math.round(tooltipItem.yLabel * 100) / 100;
                                return label + '  øre/kWh';
                            },
                            title: function (tooltipItem, chart) {
                                return 'kl  ' + tooltipItem[0].label;
                            },
                            labelTextColor: function (tooltipItem, chart) {
                                return 'white';
                            }
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    aspectRatio : 2,
                },
                barChartOptions:{
                    layout: {
                        padding: {
                            top: 50
                        }
                    },
                    animation: {
                        "duration": 1,
                        "onComplete": function (chartElm) {
                        let chartInstance = chartElm.chart,
                        ctx = chartInstance.ctx;
                        ctx.font = Chart.helpers.fontString('27px', 'normal', Chart.defaults.global.defaultFontFamily);
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'bottom';
                        //if (screen.width > '400px') {
                            this.data.datasets.forEach(function (dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function (bar, index) {
                                    var data = dataset.data[index] + '\n øre/kWh';
                                    // ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                    var lines = data.split('\n');
                                    for (var i = 0; i < lines.length; i++) {
                                        ctx.fillText(lines[i], bar._model.x, bar._model.y - 20 + (i * 15));
                                    }
                                });
                            });
                        } 
                    },
                       
                    responsive: true,
                    legend: {
                        display: false,
                    },
                    events: ['mousemove'],
                    onHover: (event, chartElement) => {
                        event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
                    },
                    hover: {
                        "animationDuration": 0
                    },
                
                    scales: {
                        yAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            },
                        
                            ticks: {
                                beginAtZero: true,
                                stepSize: 2
                            }
                        }],
                        xAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            },
                            ticks: {
                            }
                        }]
                    },
                    tooltips: {
                        enabled : true,
                        callbacks: {
                            label: function (tooltipItem, chart) {
                                let label = chart.datasets[tooltipItem.datasetIndex].label || '';
                                label += Math.round(tooltipItem.yLabel * 100) / 100;
                                return label + '  øre/kWh';
                            },
                            title: function (tooltipItem, chart) {
                                return tooltipItem[0].label;
                            },
                            labelTextColor: function (tooltipItem, chart) {
                                return 'white';
                            }
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    aspectRatio : 2,
                },
                                    
            },
            created() {
                this.getSpotprice(); 
                this.currentTab = this.sitetype === 'housing' ? 'country' : 'daily'; 
                this.activetab = this.sitetype === 'housing' ? 'country' : 'daily'; 
            },
            components: {dailygraph,weeklygraph}, 
            methods:{
                isActiveHead(tabName)
                {
                    return tabName === this.currentTab ? 'graph__head-item--active' : '';
                },
                isActiveTab(tabName)
                {
                    return tabName === this.currentTab ? 'graph__canvas--active' : '';
                },
                checkForm: function (e) {
                    if (!this.postnr) {
                        this.postnrError = 'Fyll inn postnummer';
                    }
                    else if (this.postnr){
                        this.getSpotprice();
                    }
                    e.preventDefault();
                },
                
                getSpotprice(){
                    const xhr = new XMLHttpRequest();
                    this.chartConfig.labels = false;
                    this.barChartConfig.labels = false;
                
                    xhr.onload = () => {
                        if (xhr.responseText) {
                            const result = JSON.parse(xhr.responseText);
                            this.pricelist = result.priceList;
                            this.avg = result.avg;
                            this.minpris = result.min;
                            this.response = result;
                            this.maxpris = result.max;
                            
                            if(result.error){
                                this.spotpriceError = result.error;
                            }
                            if(result.postnrError){
                                this.postnrError = result.postnrError;
                                this.area = null;
                            }else{
                                this.chartConfig.labels = result.chartlabel;
                                this.chartConfig.datasets[0].data = result.chartdata;
                                this.chartConfig = {
                                    labels: result.chartlabel,
                                    datasets: [{
                                        label: '',
                                        data: result.chartdata,
                                        pointBackgroundColor:'white',
                                        pointHoverRadius: 10,
                                        pointRadius: 5,
                                        pointBorderColor:this.bordercolor,
                                        pointHoverBackgroundColor: this.color,
                                        backgroundColor: this.color,
                                        borderColor:this.bordercolor,
                                        borderWidth: 1
                                    }],
                                };
                                this.barChartConfig = {
                                    labels: result.barchartlabel,
                                    datasets: [{
                                        label: '',
                                        data: result.barChartData,
                                        pointBackgroundColor:'white',
                                        pointHoverRadius: 10,
                                        pointRadius: 5,
                                        pointBorderColor:this.bordercolor,
                                        pointHoverBackgroundColor: this.color,
                                        backgroundColor: this.color,
                                        borderColor:this.bordercolor,
                                        borderWidth: 1
                                    }],
                                };
                            }
                            if(result.area){
                                this.area = result.area;
                                this.postnrError = null;
                            }
                            
                        } 
                    }
                    let params = `option=${this.option}`;

                    if(this.postnr){
                        params = `postnr=${this.postnr}`;
                    }
                    xhr.open('get','/actions/istad/nordpool/spotprice-graph?'+params);
                    xhr.send();
                },
                togglegraph: function(tabName){
                    this.currentTab = tabName;

                    let formElm = document.querySelector('.graph__formSection');
                    if(formElm){
                        if(this.currentTab == "country"){
                            formElm.style.display = "none";
                        }else{
                            formElm.style.display = "block";
                        }
                    }

                }
            },

        });
    },
    
}